import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AbbLoaderComponent } from '@components/abb-loader/abb-loader.component';
import { LOADING } from '@utils/loader';

@Component({
  selector: 'abb-root',
  standalone: true,
  imports: [RouterModule, AbbLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {

  constructor() {}

  loading = inject(LOADING);
}
